import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import charmhealthplaceholder from '../../assets/Loading_4.gif';
import { useNavigate } from "react-router-dom";
import { getVendorId, getVendorProfile, getVendorListings, getVendorOrders, getReviewsByVendor } from '../API_Handler'
import { useUser } from '../../UserContext';
import { useToast } from '../../Common/ToastContext';

const LoadingVendors = () => {
    const showToast = useToast();
    const navigate = useNavigate();
    const [message, setMessage] = useState('Initializing...');
    const { setUser, setUserStatus, setUserPermissions, setUserListings, setUserOrders, setUserReviews } = useUser(); // Access setUserListings using useUser hook


    const INTRO_PERMISSIONS = {
        "Dashboard": false,
        "Listings": true,
        "Orders": false,
        "Reviews": false,
        "Users": true
    }

    const NORMAL_PERMISSIONS = {
        "Dashboard": true,
        "Listings": true,
        "Orders": true,
        "Reviews": true,
        "Users": true
    }

    const fetchListings = async () => {
        setMessage('Fetching listings...');
        const userListings = await getVendorListings(showToast);
        setUserListings(userListings);
        return userListings;
    };

    const fetchOrders = () => {
        setMessage('Fetching orders...');
        getVendorOrders(showToast)
          .then((userOrders) => {
            setUserOrders(userOrders);
            return userOrders; // Return for chaining if needed
          })
          .catch((error) => {
            console.error('Error fetching orders:', error);
          });
      };
      
      const fetchReviews = () => {
        setMessage('Fetching reviews...');
        getReviewsByVendor(showToast)
          .then((userReviews) => {
            setUserReviews(userReviews);
            return userReviews; // Return for chaining if needed
          })
          .catch((error) => {
            console.error('Error fetching reviews:', error);
          });
      };
      

    // Execute each function in sequence
    useEffect(() => {
        const loadData = async () => {
            const vendorId = await getVendorId(showToast);
            if (!vendorId) {
                navigate('/vendors/login');
                return;
            }

            const vendorProfile = await getVendorProfile();
            if (!vendorProfile) {
                navigate('/vendors/error');
                return;
            }

            setUser(vendorProfile);
            //Can be "APPROVED", "PENDING", "REJECTED"
            setUserStatus(vendorProfile['approval_status']);

            if (vendorProfile['approval_status'] == "PENDING") {
                navigate('/vendors/unapproved');
                return;
            }
            if (vendorProfile['approval_status'] == "REJECTED") {
                navigate('/vendors/rejected');
                return;
            }


            // IF USER IS APPROVED, WE SET PERMISSIONS AND REDIRECT TO DASHBOARD OR LISTINGS
            // IF PERMISSIONS ARE NOT SET, WE SEND THEM BACK TO LOADING PAGE, as the pages are protected in VendorProfile.js using permissions
            const userListings = await fetchListings();
            if (!userListings) {
                navigate('/vendors/error');
                return;
            }

            // User still does not have any listings.
            if (userListings.length === 0) {
                setUserPermissions(INTRO_PERMISSIONS);
                navigate('/vendors/profile/listings');
                return;
            }
            else {
                const userOrders = fetchOrders();
                // if (!userOrders) {
                //     navigate('/vendors/error');
                //     return;
                // }
                const userReveiws = fetchReviews();
                // if (!userReveiws) {
                //     navigate('/vendors/error');
                //     return;
                // }
                setUserPermissions(NORMAL_PERMISSIONS);
                setMessage('Taking you to your dashboard...');
                navigate('/vendors/profile/dashboard');
            }
        };
        loadData();
    }, []);

    return (
        <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 bg-light">
            <img src={charmhealthplaceholder} alt="Charm Health" className="mb-4 w-[3rem]" />
            <p className="mb-4 text-md" style={{ color: 'gray' }}>{message}</p>
        </div>
    );
};

export default LoadingVendors;
